import { AnimatePresence, motion } from "framer-motion";
import { FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { navigationLinks } from "../../assets/constances";
import SocialMedia from "../SocialMedia";

const menuVars = {
  initial: {
    // opacity: 0,
    // clipPath: "circle(0.4% at 0 0)",
    clipPath: "ellipse(0% 62% at 0% 50%)",
  },
  animate: {
    // clipPath: "circle(140.5% at 99% 0)",
    clipPath: "ellipse(100% 68% at 61% 49%)",
    opacity: 1,
    transition: {
      duration: 0.3,
      // ease: [0.12, 0, 0.39, 0],
    },
  },
  exit: {
    // clipPath: "circle(0.4% at 0 0)",
    clipPath: "ellipse(0% 62% at 0% 50%)",
    // opacity: 0,
    transition: {
      delay: 0.5,
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const containerVars = {
  initial: {
    transition: {
      staggerChildren: 0.3,
      staggerDirection: -1,
    },
  },
  open: {
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.2,
      staggerDirection: 1,
    },
  },
};

export default function MobileNavigationLinks({ isOpen, toggleMenu }) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      {isOpen && (
        <motion.div
          variants={menuVars}
          initial="initial"
          animate="animate"
          exit="exit"
          className="fixed h-[dvh] inset-0 bg-black/50 z-40"
        >
          <div className="bg-white text-gray-700 h-full flex flex-col w-[80%]">
            <div className="flex items-center justify-between px-3 py-">
              <Logo />
              <span
                className="text-2xl text-darkorange border p-1"
                onClick={toggleMenu}
              >
                <FiX />
              </span>
            </div>
            <span className="block text-xl mx-4 my-3 font-bold">Menu</span>
            <motion.ul
              variants={containerVars}
              initial="initial"
              animate="open"
              exit="initial"
              className="flex-1 ml-6"
            >
              {navigationLinks.map((link, index) => (
                <div className="overflow-hidden">
                  <MobileNavLink
                    key={index}
                    link={link}
                    toggleMenu={toggleMenu}
                  />
                </div>
              ))}
            </motion.ul>
            <div className="pb-10">
              <SocialMedia cName="rounded text-xl text-darkorange" />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

const MobileNavLink = ({ link, toggleMenu }) => {
  const mobileLinkVars = {
    initial: {
      y: "80px",
      transition: {
        duration: 0.3,
        ease: [0.37, 0, 0.63, 1],
      },
    },
    open: {
      y: 0,
      transition: {
        ease: [0, 0.55, 0.45, 1],
        duration: 0.3,
      },
    },
  };
  return (
    <motion.div variants={mobileLinkVars} className="uppercase ">
      <Link className="block px-5 py-2" to={link.path} onClick={toggleMenu}>
        {link.text}
      </Link>
    </motion.div>
  );
};
